import React from 'react';
import { ReactComponent as DotIcon } from 'assets/icons/dot-icon.svg';
import { ENUM_BRAND_TYPE } from 'utils/enum';

const LiveTag = ({
  live,
  brandType = ENUM_BRAND_TYPE.FOODCOURT,
  partnerSynced = true
}: {
  live: boolean | undefined;
  brandType?: ENUM_BRAND_TYPE;
  partnerSynced?: boolean;
}) => {
  return (
    <div>
      <div
        className={`border w-fit min-h-fit ${
          live
            ? 'text-[#46AE31] bg-[#EAF8E7] border-[#A8E39C]'
            : 'text-[#858585] bg-[#F0F0F0] border-[#DEDEDE]'
        }  py-[3px] px-3 text-sm rounded-full  flex justify-center gap-2 items-center`}>
        <DotIcon color='currentColor' />

        {brandType === ENUM_BRAND_TYPE.FOODCOURT ? (
          <p className='text-sm font-medium'>{live ? 'Live' : 'Yet to go live'}</p>
        ) : (
          <p>{partnerSynced ? 'Synced' : 'Not Synced'}</p>
        )}
      </div>
    </div>
  );
};

export default LiveTag;
